import { render, staticRenderFns } from "./GardenerLocationAreas.vue?vue&type=template&id=0860d378"
import script from "./GardenerLocationAreas.vue?vue&type=script&lang=js"
export * from "./GardenerLocationAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports